/**
 * 获取 blob
 * @param  {String} url 目标文件地址
 * @return {Promise} 
 */
export function getBlob(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()
    url = url + `?r=${Math.random()}`
    xhr.open("GET", url, true)
    xhr.responseType = "blob"
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response)
      }
    }

    xhr.send()
  })
}

/**
* 保存
* @param  {Blob} blob     
* @param  {String} fileName 想要保存的文件名称
* @param  {String} type 想要保存的文件名称
*/
export function downloadFileByBlob(data, fileName, type) {
  let options = {}
  if (type) {
    options = { type: `application/${type}` }
  }
  const blob = new Blob([data], options)
  if ("download" in document.createElement("a")) { // 非IE下载
    const alink = document.createElement("a")
    alink.download = fileName
    alink.style.display = "none"
    alink.href = URL.createObjectURL(blob)
    document.body.appendChild(alink)
    alink.click()
    URL.revokeObjectURL(alink.href) // 释放URL 对象
    document.body.removeChild(alink)
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName)
  }
}

/**
* 下载
* @param  {String} url 目标文件地址
* @param  {String} filename 想要保存的文件名称
*/
export function downloadFileByUrl(url, filename, type) {
  getBlob(url).then(blob => {
    downloadFileByBlob(blob, filename, type)
  })
}

// 通过contentDisposition 获取文件名
export function getFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) {
    return null
  }
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
  const matches = filenameRegex.exec(contentDisposition)
  if (matches && matches[1]) {
    return decodeFilename(matches[1].replace(/['"]/g, "").replace("UTF-8", ""))
  }
  return null
}
function decodeFilename(filename) {
  // 处理UTF-8编码的文件名
  if (filename.includes("%")) {
    try {
      return decodeURIComponent(filename)
    } catch (e) {
      return filename
    }
  }
  // 处理ISO-8859-1编码的情况
  if (/=\?/.test(filename)) {
    try {
      return decodeURIComponent(escape(filename))
    } catch (e) {
      return filename
    }
  }
  return filename
}